import { useState } from 'react';
import classNames from 'classnames/bind';
import styles from './AddGroup.module.css';

import { useValidateGroupNameMutation } from '../../../../services/group';

import Item from '../Item';
import Input from '../../../Input';
import { ENTER_GROUP_NAME, GROUP_NAME } from '../../../../constants';

interface AddGroup {
  onChange: (e: React.ChangeEvent<HTMLInputElement>, isFilled: boolean) => void;
}
export default function AddGroup({ onChange }: AddGroup) {
  const cx = classNames.bind(styles);
  const [isValid, setIsValid] = useState(false);
  const [validatedMsg, setValidatedMsg] = useState('');

  const [validateGroupName] = useValidateGroupNameMutation();

  const validate = async (e: React.FocusEvent<HTMLInputElement>) => {
    const { value } = e.target;
    try {
      const res = await validateGroupName(value);
      const msg = (res as { data: string }).data;
      const isOk = msg === 'OK';

      setIsValid(isOk);
      setValidatedMsg(msg);
      onChange(e, value !== '' && isOk);
    } catch (error) {
      console.error('Failed to validate group name', error);
    }
  };

  return (
    <Item id="addGroup">
      <div className={cx('panel_row')}>
        <span className={cx('sub', 'h48')}>{GROUP_NAME}</span>
        <div className={cx('detail')}>
          <div className={cx('input_box', 'lone', 'input--error')}>
            <span className={cx('blind')}>{GROUP_NAME}</span>
            <Input
              type="text"
              id="nm"
              placeholder={ENTER_GROUP_NAME}
              onBlur={validate}
              limit={20}
            />
            {!isValid && <span className={cx('msg')}>{validatedMsg}</span>}
          </div>
        </div>
      </div>
    </Item>
  );
}
